import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NotFoundCont, NotFoundTitle } from './404.styles';

const Page404: FC = () => {
  const { t } = useTranslation();

  return (
    <NotFoundCont>
      <NotFoundTitle>
        {t('notFound.404')} <br />
        <b>{t('notFound.notFound')}</b>
      </NotFoundTitle>
    </NotFoundCont>
  );
};

export default Page404;
